// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3596":"subscription","3715":"list","7962":"home","9566":"shorts-pill","9702":"story"}[chunkId] || chunkId) + "-" + {"3596":"6269c8dc2db49e03a16d","3715":"d741d5fa013520253cc0","7539":"239b3113388310ad8fda","7962":"f5394bcf05fb8faf17a8","9566":"713fd2a7748cb24ac155","9702":"92710e1988944b43ccdc"}[chunkId] + ".css";
};